var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-button"},[_c('vs-tooltip',{attrs:{"text":"編集","position":"bottom"}},[_c('div',{staticClass:"action-button-icon",on:{"click":function($event){$event.stopPropagation();return _vm.onClickEdit(null)}}},[_c('vs-icon',{staticClass:"material-icons-outlined",attrs:{"icon":"edit","size":"22px"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }